/* ── KayoBaby wishlist ─────────────────────────────────────────────
   Stores saved products in localStorage (no app/account needed).
   Used by the PDP heart button and the wishlist page. */
(function () {
  var KEY = 'kb_wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('kb:wishlist:change', { detail: { count: list.length } }));
  }

  function has(id) {
    return read().some(function (i) { return String(i.id) === String(id); });
  }

  function toggle(item) {
    var list = read();
    var i = list.findIndex(function (x) { return String(x.id) === String(item.id); });
    if (i > -1) { list.splice(i, 1); } else { list.unshift(item); }
    write(list);
    return i === -1; /* true = added */
  }

  function remove(id) {
    write(read().filter(function (i) { return String(i.id) !== String(id); }));
  }

  /* ── Heart buttons ── */
  function paintButton(btn) {
    var on = has(btn.dataset.id);
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function paintAll() {
    document.querySelectorAll('[data-wish-toggle]').forEach(paintButton);
    paintCount();
  }

  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function toast(msg) {
    var t = document.getElementById('kb-wish-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'kb-wish-toast';
      t.className = 'kb-wish-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    clearTimeout(t.__h);
    t.classList.remove('is-visible');
    void t.offsetWidth;
    t.classList.add('is-visible');
    t.__h = setTimeout(function () { t.classList.remove('is-visible'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wish-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    var added = toggle({
      id: btn.dataset.id,
      handle: btn.dataset.handle,
      title: btn.dataset.title,
      url: btn.dataset.url,
      image: btn.dataset.image,
      price: btn.dataset.wishPrice
    });
    paintButton(btn);
    paintCount();
    btn.classList.remove('kb-wish-pop');
    void btn.offsetWidth;
    btn.classList.add('kb-wish-pop');
    toast(added ? 'Added to wishlist' : 'Removed from wishlist');
    if (window.__kbRenderWishlist) window.__kbRenderWishlist();
  });

  /* Remove buttons on the wishlist page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wish-remove]') : null;
    if (!btn) return;
    e.preventDefault();
    remove(btn.dataset.id);
    paintAll();
    toast('Removed from wishlist');
    if (window.__kbRenderWishlist) window.__kbRenderWishlist();
  });

  document.addEventListener('kb:wishlist:change', paintCount);

  function init() { paintAll(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.KBWishlist = { read: read, has: has, remove: remove, paintAll: paintAll };
})();
